import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Outlet, Navigate } from "react-router-dom"; // Importe o Navigate
import SidebarCliente from "./SideBarPainel";
import Loading from "./Loading";
import TabsMobile from "./TabsMobile";
import MobileHeader from "./MobileHeader";
import { useBarbeiro } from "../context/BarbeiroContext";
import RequireActivePlan from "./RequireActivePlan";

/* ... MANTENHA OS STYLED COMPONENTS IGUAIS ... */
const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  background: #f3f7ff;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    overflow: visible;
  }
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  max-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding-bottom: 72px;
    overflow-y: visible;
    max-height: none;
  }
`;

// Adicionei um container para garantir que o Loading fique centralizado na tela cheia
const FullPageLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f3f7ff; 
`;

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = (e) => setIsMobile(e.matches);
    handler(mq);
    mq.addEventListener?.("change", handler);
    if (!mq.addEventListener) mq.addListener(handler);
    return () => {
      mq.removeEventListener?.("change", handler);
      if (!mq.removeEventListener) mq.removeListener(handler);
    };
  }, [breakpoint]);

  return isMobile;
}

export default function PainelLayout() {
  const { barbeiro, loadingBarbeiro } = useBarbeiro();
  const isMobile = useIsMobile();

  // 1. VERIFICAÇÃO DE CARREGAMENTO (PRIORIDADE MÁXIMA)
  // Enquanto estiver carregando, retorna APENAS o loading.
  // O Sidebar e o LayoutContainer nem chegam a ser montados.
  if (loadingBarbeiro) {
    return (
      <FullPageLoadingContainer>
        <Loading />
      </FullPageLoadingContainer>
    );
  }

  // 2. VERIFICAÇÃO DE AUTENTICAÇÃO
  // Se parou de carregar e NÃO existe barbeiro, manda para o login.
  // Isso evita erros ao tentar acessar propriedades de 'undefined' no Sidebar.
  if (!barbeiro) {
    return <Navigate to="/login" replace />;
  }

  const primeiroNome = barbeiro?.nome || "Barbeiro";
  const barbeariaId = barbeiro?.barbeariaId || barbeiro?.uid;

  // 3. RENDERIZAÇÃO DO LAYOUT (SÓ ACONTECE SE TIVER CARREGADO E LOGADO)
  return (
    <RequireActivePlan barbeariaId={barbeariaId}>
      <LayoutContainer>
        {!isMobile && <SidebarCliente />}
        
        {isMobile && (
          <MobileHeader
            userName={primeiroNome}
            photoURL={
              barbeiro?.foto ||
              "https://firebasestorage.googleapis.com/v0/b/bigode-app-fade.firebasestorage.app/o/padrao-sistema%2Fbarbeiro.webp?alt=media&token=732c1f69-8182-414d-8237-ac0f509bf0fd"
            }
            onHelp={() => (window.location.href = "/ajuda")}
          />
        )}

        <Content>
           <Outlet />
        </Content>

        {isMobile && <TabsMobile />}
      </LayoutContainer>
    </RequireActivePlan>
  );
}